import { IsNotEmpty, IsString, MaxLength, IsNumber, IsBoolean, IsISO8601 } from 'class-validator';

export class NotificationEditDTO {

    @IsNotEmpty()
    @IsString()
    @MaxLength(255)
    name: string;

    @IsNotEmpty()
    @IsNumber()
    entity: number;

    @IsNotEmpty()
    @IsNumber()
    event: number;

    @IsNotEmpty()
    @IsNumber()
    type: number;

    @IsNotEmpty()
    @IsString()
    body: string;

    @IsNotEmpty()
    @IsBoolean()
    active: boolean;

    @IsNotEmpty()
    @IsISO8601()
    from: string;

    @IsNotEmpty()
    @IsISO8601()
    to: string;

    @IsNotEmpty()
    @IsBoolean()
    monday: boolean;

    @IsNotEmpty()
    @IsBoolean()
    tuesday: boolean;

    @IsNotEmpty()
    @IsBoolean()
    wednesday: boolean;

    @IsNotEmpty()
    @IsBoolean()
    thursday: boolean;

    @IsNotEmpty()
    @IsBoolean()
    friday: boolean;

    @IsNotEmpty()
    @IsBoolean()
    saturday: boolean;

    @IsNotEmpty()
    @IsBoolean()
    sunday: boolean;

}
